/**
 * What a session shows where it has no image (`image_url` null, Images Phase 0a,
 * `docs/images-2026-10/image-plan.md` §4.0): the S1 placeholder, a gradient with a Play icon.
 * Decorative: the session's title is always next to it.
 */
import { Play } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * S1 navy #02344a → leaf #004d71 → teal #06706d: the sky of the A4 acoustic placeholders
 * (`public/assets/acoustic/*.svg`) and of Home's Akustične card (`HOME_IMAGES.acoustic`).
 * Image boxes carry it too, so an image that fails to load leaves the placeholder, not a blank.
 */
export const SESSION_IMAGE_GRADIENT = 'bg-gradient-to-br from-[#02344a] via-[#004d71] to-[#06706d]';

interface SessionImageFallbackProps {
  /** Size, shape and position of the box, e.g. `absolute inset-0` or `h-48 rounded-xl`. */
  className?: string;
  /** Size of the Play icon. */
  iconClassName?: string;
}

/** A `span`, so it is valid inside the buttons and links that hold session images. */
export function SessionImageFallback({ className, iconClassName = 'h-8 w-8' }: SessionImageFallbackProps) {
  return (
    <span
      aria-hidden="true"
      data-session-image-fallback=""
      className={cn('flex items-center justify-center', SESSION_IMAGE_GRADIENT, className)}
    >
      {/* S1 cream #f9f3ed */}
      <Play className={cn('text-[#f9f3ed]/80', iconClassName)} aria-hidden="true" />
    </span>
  );
}
